import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';

import { State } from './types';

export const fetchServiceTypes = createAction('serviceTypes/fetch', () => ({
  payload: undefined,
}));

export const fetchedServiceTypes = createAction(
  'serviceTypes/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchServiceTypes,
  fetchedServiceTypes,
};
